import React from "react";
import {
  Button,
  Modal,
  PageHeader,
  PageTitle,
} from "../../../../../../components";

const BulkLcaDelete = ({ onClose, isOpen }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Bulk LCA Delete"
      width="max-w-3xl"
    >
      <PageHeader
        Section={
          <div className="mt-5">
            <PageTitle
              title={"Are you sure you want to delete LCA(s) ?"}
              icon={"info"}
              tag="p"
            />
          </div>
        }
      />
      <div className="flex gap-3 justify-end my-10">
        <Button title="No" variant="outlined" onClick={onClose} />
        <Button title="Yes" onClick={onClose} />
      </div>
    </Modal>
  );
};

export default BulkLcaDelete;
